// src/hooks/cities/useForceDeleteCity.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteCity } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useForceDeleteCity = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteCityMutate, isPending } = useMutation({
        mutationFn: forceDeleteCity,
        onSuccess: (res) => {
            const message = res?.message || "City force deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to force delete city");
        },
    });

    return { forceDeleteCityMutate, isPending };
};

export default useForceDeleteCity;